import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  requestLicenseDetailFailed,
  requestLicenseDetailSuccess,
  requestLicenseReferencesFailed,
  requestLicenseReferencesSuccess,
  requestLicensesFailed,
  requestLicensesSuccess,
  syncUsageFailed,
  syncUsageSuccess
} from '../../actions/resources/License';
import LicenseAPI from '../../api/resources/License';
import * as Constants from '../../constants/resources';
import { LicenseReferencesPayload } from '../../types/resources/State';

function* getLicenses() {
  try {
    const licenses = yield call(LicenseAPI.getLicenses);
    yield put(requestLicensesSuccess(licenses));
  } catch (e) {
    yield put(requestLicensesFailed());
  }
}
function* watchForLicenses() {
  yield takeLatest(Constants.LICENSES, getLicenses);
}

function* getLicenseDetail(payload: LicenseReferencesPayload) {
  try {
    const licenseDetail = yield call(LicenseAPI.getLicenseDetail, payload);
    yield put(requestLicenseDetailSuccess(licenseDetail));
  } catch (e) {
    yield put(requestLicenseDetailFailed());
  }
}
function* triggerSyncUsage(payload: LicenseReferencesPayload) {
  try {
    const syncUsage = yield call(LicenseAPI.triggerSyncUsage, payload);
    yield put(syncUsageSuccess(syncUsage));
  } catch (e) {
    yield put(syncUsageFailed());
  }
}

function* watchForLicenseDetail() {
  yield takeLatest(Constants.LICENSE_DETAIL, getLicenseDetail);
}
function* watchForSyncUsage() {
  yield takeLatest(Constants.LICENSE_SYNC_USAGE, triggerSyncUsage);
}

function* getLicenseReferences(payload: LicenseReferencesPayload) {
  try {
    const licenseReferences = yield call(
      LicenseAPI.getLicenseReferences,
      payload
    );
    yield put(requestLicenseReferencesSuccess(licenseReferences));
  } catch (e) {
    yield put(requestLicenseReferencesFailed());
  }
}

function* watchForLicenseReferences() {
  yield takeLatest(Constants.LICENSE_REFERENCES, getLicenseReferences);
}

export default function* homeSaga() {
  yield all([
    watchForLicenses(),
    watchForLicenseDetail(),
    watchForSyncUsage(),
    watchForLicenseReferences()
  ]);
}
